import { render, staticRenderFns } from "./FriendsTagItem.vue?vue&type=template&id=f9619630&"
import script from "./FriendsTagItem.vue?vue&type=script&lang=js&"
export * from "./FriendsTagItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvatarWithInfo: require('/opt/buildhome/repo/components/global/Avatar/AvatarWithInfo.vue').default})
